export default __webpack_public_path__ + "static/69798-92506043105caabcdd769e8c82cdcd78.jpg";